import { useTranslation } from "react-i18next";
import { formatPercentage } from "@shared/helpers";

import { SummaryRow } from "./components";

import type { CarouselDoneProps } from "./carousel-done.type";
import styles from "./carousel-done.module.css";

export const CarouselDone = ({
  acceptedCount,
  skippedCount,
  totalImpact,
  total,
  onReview,
}: CarouselDoneProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["done-screen"]}>
      <div className={styles["done-label"]}>
        <span className={styles["done-dot"]} />
        {t("payfac.pagePendenciesCarouselDoneBadge")}
      </div>

      <div>
        <p className={styles["done-title"]}>
          {t("payfac.pagePendenciesCarouselDoneTitle")}
        </p>
        <p className={styles["done-subtitle"]}>
          {t("payfac.pagePendenciesCarouselDoneSubtitle", { total })}
        </p>
      </div>

      <div className={styles.summary}>
        <SummaryRow
          label={t("payfac.pagePendenciesCarouselAccepted")}
          value={String(acceptedCount)}
        />
        <SummaryRow
          label={t("payfac.pagePendenciesCarouselSkipped")}
          value={String(skippedCount)}
        />
        <SummaryRow
          label={t("payfac.pagePendenciesCarouselConsolidatedImpact")}
          value={formatPercentage(totalImpact)}
          highlight
          separator
        />
      </div>

      <button className={styles["btn-text"]} onClick={onReview}>
        {t("payfac.pagePendenciesCarouselReview")}
      </button>
    </div>
  );
};
